var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"mx-auto text-center mt-2 mb-2",attrs:{"color":"white","flat":""}},[_c('v-card-text',[_c('canvas',{ref:"myChart",attrs:{"width":"100","height":"40"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }